
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black text-white pt-16 pb-8 border-t border-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <h3 
              className="text-2xl font-bold mb-4"
              style={{ fontFamily: '"Pacifico", serif' }}
            >
              Another Piercing Co
            </h3>
            <p className="text-gray-400 mb-4 leading-relaxed">
              Professional body piercing services in Wichita with jewelry included. Walk-ins welcome at both locations.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://www.facebook.com/profile.php?id=61551921834097" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-900 hover:bg-red-600 rounded-lg transition-colors cursor-pointer border border-gray-800"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a 
                href="https://www.instagram.com/tiatnttheneedletemptress/" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-900 hover:bg-red-600 rounded-lg transition-colors cursor-pointer border border-gray-800"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-red-500 transition-colors cursor-pointer"
                >
                  Services
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('artists')}
                  className="text-gray-400 hover:text-red-500 transition-colors cursor-pointer"
                >
                  Our Artists
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="text-gray-400 hover:text-red-500 transition-colors cursor-pointer"
                >
                  About Us
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-red-500 transition-colors cursor-pointer"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Services</h4>
            <ul className="space-y-3">
              <li className="text-gray-400">Ear Piercings</li>
              <li className="text-gray-400">Nose Piercings</li>
              <li className="text-gray-400">Face Piercings</li>
              <li className="text-gray-400">Body Piercings</li>
              <li className="text-gray-400">Custom Piercings</li>
              <li className="text-gray-400">Jewelry Upgrades</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Contact Info</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-red-500 mt-1"></i>
                <span className="text-gray-400">
                  8663 West Central<br />
                  Wichita, KS
                </span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-red-500"></i>
                <a 
                  href="tel:3168807760"
                  className="text-gray-400 hover:text-red-500 transition-colors cursor-pointer"
                >
                  (316) 880-7760
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-900 pt-8">
          <div className="flex flex-col md:flex-row justify-center items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Another Piercing Co. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
